export default __webpack_public_path__ + "static/media/601.d5535a97.jpg";